'use client'
import { Avatar } from 'primereact/avatar'
import React, { useState } from 'react'
import NoProfile from "@/assets/image/no-profile-picture.svg"
import { useDispatch } from 'react-redux'
import { logout } from '../features/slices/authSlice'
import Link from 'next/link'

const Header = ({ isSidebarOpen, setIsSidebarOpen }) => {
  const dispatch = useDispatch();
  const [openSettingDropDown, setOpenSettingDropDown] = useState(false)

  const handleLogout = async () => {
    await dispatch(logout())

  }
  return (
    <header className="!h-20 !bg-white !shadow-sm !flex !items-center !justify-between !px-8">
      <div className="!flex !items-center !gap-4">
        <button onClick={() => setIsSidebarOpen(!isSidebarOpen)} className="!p-2 hover:!bg-gray-100 !rounded-lg !text-gray-600">
          <i className="pi pi-bars !text-xl"></i>
        </button>
        <div className="!relative">
          <i className="pi pi-search !absolute !left-3 !top-1/2 !-translate-y-1/2 !text-gray-400"></i>
          <input type="text" placeholder="Search bookings..." className="!pl-10 !pr-4 !py-2 !rounded-full !bg-gray-100 !text-sm focus:!outline-none focus:!ring-2 focus:!ring-blue-500 !w-64 !transition-all" />
        </div>
      </div>

      <div className="!flex !items-center !gap-6">
        {/* <div className="!relative cursor-pointer">
          <i className="pi pi-bell !text-xl !text-gray-600"></i>
          <span className="!absolute !-top-1 !-right-2 !w-4 !h-4 !bg-red-500 !rounded-full !text-[10px] !text-white !flex !items-center !justify-center">3</span>
        </div> */}
        <div className="!cursor-pointer !relative" onClick={() => setOpenSettingDropDown(!openSettingDropDown)}>
          <i className="pi pi-cog !text-xl !text-gray-600"></i>
          {openSettingDropDown && (
            <div className="!absolute !right-0 !top-[calc(100%+10px)] !w-56 !bg-white !border !border-gray-200 !rounded-2xl !shadow-[0_20px_50px_rgba(0,0,0,0.15)] !overflow-hidden !z-[9999] !block">
              <div className="!py-2">
                <Link href="/profile" onClick={() => setOpenSettingDropDown(false)} className="!block !px-5 !py-4 !border-b !border-gray-50 hover:!bg-blue-50 !transition-colors !cursor-pointer !group">
                  <span className="!flex !items-center !text-sm !font-black !text-slate-800 group-hover:!text-blue-600">
                    <i className="pi pi-user !mr-3 !text-lg !text-slate-400 group-hover:!text-blue-500"></i> Profile
                  </span>
                </Link>
                <div className="!px-5 !py-4 hover:!bg-red-50 !transition-colors !cursor-pointer !group" onClick={handleLogout}>
                  <span className="!flex !items-center !text-sm !font-black !text-red-600">
                    <i className="pi pi-power-off !mr-3 !text-lg !text-red-400 group-hover:!text-red-600"></i> Logout
                  </span>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </header>
  )
}

export default Header
